import request from '@/utils/request'
const apiPath = '/course/courseSubjectBarrierStage'
import { downloadBlob } from '@/utils/download'
const courseSubjectBarrierStageApi = {
  /**
   * 新增【课程管理闯关模式阶段】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程管理闯关模式阶段】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程管理闯关模式阶段】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 
   * 查看【课程管理闯关模式阶段】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程管理闯关模式阶段】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchDeleted(data) {
    return request.post(apiPath + '/setDeleted', data, { isFormData: 1 })
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
}
export default courseSubjectBarrierStageApi
